/* eslint-disable import/order */
import { listEmbedEntryPoint } from '@jira/spa-apps__business-jsw-list-embed/src/listEmbedEntryPoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwareListEmbedRoute } from '@jira/router-routes__software-list-routes/src/softwareListEmbedRoute.tsx';
import { ListEmbedSkeleton } from '@jira/platform__skeletons/src/ui/list/ListSkeleton.tsx';
import { EmbedIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { getCommonProjectResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { issueNavigatorEmbedPageEntryPoint } from '@jira/router-routes__issue-navigator-entries/src/ui/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getListProjectResources } from './common/getListProjectResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

const listEmbedPageEntrypoint = createChromelessEntryPoint({
	main: listEmbedEntryPoint,
});

export const softwareListEmbedRouteEntry: Route = createEntry(softwareListEmbedRoute, () => ({
	group: 'software',
	skeleton: fg('jira_list_nin_merge') ? EmbedIssueNavigatorSkeleton : ListEmbedSkeleton,

	entryPoint() {
		if (fg('jira_list_nin_merge')) {
			return issueNavigatorEmbedPageEntryPoint;
		}
		return listEmbedPageEntrypoint;
	},

	layout: chromelessLayout,

	resources: fg('jira_list_nin_merge')
		? [...getCommonProjectResources(), getConsolidationStateResource()]
		: [...getNavigationResources(), ...getListProjectResources()],

	ufoName: fg('jira_list_nin_merge') ? 'software-list-nin-embed' : 'next-gen-list-embed',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
